
import axios from "axios";
import { base_url, config } from "../../utils/axiosConfig";
 
const getProducts = async (data) => {
  const response = await axios.get(`${base_url}product?${data?.tag ? `tags=${data?.tag}&&` : ""}${data?.category ? `category=${data?.category}&&` : ""}${data?.minPrice ? `price[gte]=${data?.minPrice}&&` : ""}${data?.maxPrice ? `price[lte]=${data?.maxPrice}&&` : ""}${data?.sort ? `sort=${data?.sort}&&` : ""}`);
  if (response.data) {
    return response.data;
  }
};

const getSingleProduct = async (slug) => {
  const response = await axios.get(`${base_url}product/${slug}`);
  if (response.data) {
    return response.data;
  }
};

const getRelatedProducts = async (productSlug) => {
  const response = await axios.get(`${base_url}product/${productSlug}/related`);
  if (response.data) {
    return response.data;
  }
};





export const productService = {
  getProducts,
  getSingleProduct,
  getRelatedProducts,
  
};
